<template>
  <b-modal
    id="form-modal-create-activity"
    size="xl"
    centered
    hide-footer
    @hidden="resetModal"
    @close="resetModal"
    no-close-on-backdrop
    no-close-on-esc
    full
    :title="
      selectedItem?.action === 'create'
        ? 'Thêm mới hoạt động'
        : 'Cập nhật hoạt động'
    "
  >
    <b-container fluid>
      <FormProgramCreateActivity
        @close-modal="resetModal"
        :setupData="setupData"
        :selectedItem="selectedItem"
      />
    </b-container>
  </b-modal>
</template>

<script>
import FormProgramCreateActivity from '../../TranProgramActivityUpdate.vue';
export default {
  name: 'FormModalActivity',
  components: {
    FormProgramCreateActivity,
  },
  props: {
    setupData: {
      type: Object,
      default: () => {},
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    resetModal() {
      this.$emit('loadData');
      this.$bvModal.hide('form-modal-create-activity');
    },
    openModal() {
      this.$bvModal.show('form-modal-create-activity');
    },
  },
};
</script>
<style>
#form-modal-create-activity {
  padding: -0.25rem !important;
}
</style>
